import React, { useMemo } from 'react'
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom'

import ButtonBase from '@mui/material/ButtonBase'
import { makeStyles } from '@mui/styles'
import Typography from '@mui/material/Typography'

import { useAuth } from 'hooks/useAuth'
import loginImage from 'images/icons/login.png'
import userImage from 'images/icons/user.png'

const useStyles = makeStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    background: theme.palette.background.paper,
  },
  container: {
    width: '100%',
    maxWidth: 800,
    margin: '0 auto',
    padding: theme.spacing(3, 0),
    display: 'flex',
    position: 'relative',
  },
  logoWrapper: {
    marginLeft: theme.spacing(3),
  },
  logo: {
    height: 40,
    objectFit: 'contain',
  },
  button: {
    marginRight: `${theme.spacing(3)} !important`,
    position: 'absolute !important',
    right: '0 !important',
  },
  icon: {
    '& path': {
      stroke: theme.palette.action.active,
    },
  },
}))

export default function NavBar() {
  const { t } = useTranslation();
  const classes = useStyles()
  const { push } = useHistory()
  const { user, initialized } = useAuth()

  const Button = ({ children, image, onClick }) => (
    <ButtonBase
      className={classes.button}
      onClick={onClick}
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <img alt={children} src={image} width="24" height="24" />
      <Typography variant="caption" color="textPrimary" component="p" style={{ minWidth: 60, textTransform: 'none' }}>
        {children}
      </Typography>
    </ButtonBase>
  )

  const Menu = useMemo(() => {
    if (!initialized) {
      return null
    }
    if (user) {
      return (
        <Button image={userImage} onClick={() => push('/users/me')}>
          {t("Word.MyPage")}
        </Button>
      )
    }
    return (
      <Button image={loginImage} onClick={() => push('/login')}>
        {t("Word.SignIn")}
      </Button>
    )
  }, [initialized, user, push, t])

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <div className={classes.logoWrapper}>
          <ButtonBase onClick={() => push(process.env.REACT_APP_ACCOUNT_ID === '39' && process.env.REACT_APP_TOP_REDIRECT ? process.env.REACT_APP_TOP_REDIRECT : '/')}>
            <img src="/images/logo.png" alt="Logo" className={classes.logo} />
          </ButtonBase>
        </div>
        {Menu}
      </div>
    </div>
  )
}
